import { ReferenceType } from '../../../../../../../../../../../backend/src/types/types';
import { cn } from '@/new/lib/utils';

export function Reference({
  index,
  id,
  referenceType,
  onClick,
}: {
  index: number;
  id: string;
  referenceType: ReferenceType;
  onClick?: (id: string, referenceType: ReferenceType) => void;
}) {
  return (
    <span
      className={cn(
        'font-inter mr-px ml-0.75 inline-block -translate-y-px rounded-md border border-gray-300 bg-white px-1 text-[10px] font-normal text-gray-500',
        onClick && 'cursor-pointer',
        referenceType === ReferenceType.Fact &&
          'border-blue-300 bg-blue-50 text-blue-500 duration-150 hover:border-blue-400 hover:bg-blue-100 hover:text-blue-600',
        referenceType === ReferenceType.Chunk && 'border-orange-300 bg-orange-50 text-orange-500',
        referenceType === ReferenceType.Entity && 'border-green-300 bg-green-50 text-green-500',
        referenceType === ReferenceType.Document && 'border-purple-300 bg-purple-50 text-purple-500',
      )}
      onClick={onClick ? () => onClick(id, referenceType) : undefined}
    >
      {index || '?'}
    </span>
  );
}
